import { CookieConstants } from '../../constants'
import { defaultObj } from './state'

import session from '../../utility/sessionUtil'
import store from '../index'

export default {
  setAppAndCustomerId (state, info) {
    if (info.applicationId !== undefined) {
      state.applicationId = info.applicationId
    }

    if (info.customerId !== undefined) {
      state.customerId = info.customerId
    }
    store.commit('origination/updateCookie')
  },

  setOriginationInfo (state, info) {
    if (info.appraisalId !== undefined) {
      state.appraisalId = info.appraisalId
    }

    if (info.customerId !== undefined) {
      state.customerId = info.customerId
    }

    if (info.maxLoanAmount !== undefined) {
      state.maxLoanAmount = info.maxLoanAmount
    }

    if (info.minLoanAmount !== undefined) {
      state.minLoanAmount = info.minLoanAmount
    }

    if (info.productId !== undefined) {
      state.productId = info.productId
    }

    if (info.loanStatusId !== undefined) {
      state.loanStatusId = info.loanStatusId
    }

    if (info.loanTypeCode !== undefined) {
      state.loanTypeCode = info.loanTypeCode
    }

    if (info.locationId !== undefined) {
      state.locationId = info.locationId
    }

    if (info.locationBrand !== undefined) {
      state.locationBrand = info.locationBrand
    }

    if (info.storeId !== undefined) {
      state.storeId = info.storeId
    }

    if (info.loanValidations !== undefined) {
      if (info.loanValidations.bridgePayDisbursementEnabled !== undefined) {
        state.disbursementOptions.bridgePayOrigDisbEnabled = info.loanValidations.bridgePayDisbursementEnabled
      }

      if (info.loanValidations.isDebitDisbursementAvailable !== undefined) {
        state.disbursementOptions.isDebitDisbursementAvailable = info.loanValidations.isDebitDisbursementAvailable
      }

      if (info.loanValidations.isMoneyGramDisbursementAvailable !== undefined) {
        state.disbursementOptions.isMoneyGramDisbursementAvailable = info.loanValidations.isMoneyGramDisbursementAvailable
      }

      if (info.loanValidations.isStoreDisbursementAvailable !== undefined) {
        state.disbursementOptions.isStoreDisbursementAvailable = info.loanValidations.isStoreDisbursementAvailable
      }
    }
    store.commit('origination/updateCookie')
  },

  setDisbursementAmount (state, amount) {
    state.disbursementAmount = amount
    store.commit('origination/updateCookie')
  },

  setDisbursementType (state, disbursementTypeEnum) {
    state.disbursementType = disbursementTypeEnum
    store.commit('origination/updateCookie')
  },

  setOriginationKey (state, originationKey) {
    state.originationKey = originationKey
    store.commit('origination/updateCookie')
  },

  setNewLoanInfo (state, newLoanInfo) {
    state.collateral = newLoanInfo.collateral
    state.dueDate = newLoanInfo.dueDate
    state.loanAmount = newLoanInfo.loanAmount
    state.loanId = newLoanInfo.loanId
    store.commit('origination/updateCookie')
  },

  updateCookie (state) {
    session.deleteCookie(CookieConstants.origination.key + state.customerId)
    session.setCookie(CookieConstants.origination.key + state.customerId, JSON.stringify(state), CookieConstants.origination.ttlMinutes)
  },

  reset (state, stateProperties = defaultObj) {
    state = Object.assign(state, stateProperties)
  }
}
